import { render } from "./DependentsComponent.vue?vue&type=template&id=72cddec4&scoped=true"
import script from "./DependentsComponent.vue?vue&type=script&lang=js"
export * from "./DependentsComponent.vue?vue&type=script&lang=js"

import "./DependentsComponent.vue?vue&type=style&index=0&id=72cddec4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cddec4"]])

export default __exports__